import { render, staticRenderFns } from "./sliderArticle.edit.vue?vue&type=template&id=96fab812&scoped=true"
import script from "./sliderArticle.edit.vue?vue&type=script&lang=js"
export * from "./sliderArticle.edit.vue?vue&type=script&lang=js"
import style0 from "./sliderArticle.edit.vue?vue&type=style&index=0&id=96fab812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fab812",
  null
  
)

export default component.exports